import React, { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { fmtDate, usePaged } from '../../hooks';
import { Badge, Button, Card, Select, SearchBox } from '../../ui/basics';
import { DataTable } from '../../ui/DataTable';
import CandidateDetail from './CandidateDetail';
import CandidateForm from './CandidateForm';
import { docFile } from './docs';
import { StatusBadge } from './OfferActions';

export default function Candidates({ org }) {
  const { user } = useAuth();
  const paged = usePaged('onboardings/', { fixed: { organization: org }, initialOrdering: '-createdat' });
  const { filters, setFilter, clearFilters, data, reload } = paged;
  const [dialog, setDialog] = useState(null); // { type: 'add' } | { type: 'view', row }

  const columns = [
    { key: 'candidate_name', label: 'Candidate', sortable: true, render: (r) => <div><b>{r.candidate_name}</b><div className="muted">{r.candidate_email}</div></div> },
    { key: 'client', label: 'Client', sortable: true },
    { key: 'facility', label: 'Facility', sortable: true },
    { key: 'job_title', label: 'Job title' },
    { key: 'onboarding_status', label: 'Status', sortable: true, render: (r) => <StatusBadge row={r} /> },
    { key: 'executive', label: 'Executive', render: (r) => <span className="muted">{(r.onboarding_executive || r.user || '—').split('@')[0]}</span> },
    { key: 'offer_date', label: 'Offer date', render: (r) => fmtDate(r.offer_date) },
    { key: 'expected_start_date', label: 'Expected start', render: (r) => fmtDate(r.expected_start_date) },
    { key: 'documents', label: 'Documents', render: (r) => {
      const docs = r.required_documents || [];
      const got = docs.filter((d) => docFile(d)).length;
      return <Badge tone={docs.length && got === docs.length ? 'success' : got ? 'warning' : ''}>{got} / {docs.length} received</Badge>;
    } },
    { key: 'createdat', label: 'Created', sortable: true, render: (r) => fmtDate(r.createdat) },
  ];

  return (
    <>
      <Card flush>
        <div className="toolbar">
          <SearchBox value={filters.search} onChange={(v) => setFilter('search', v)} placeholder="Search name, email, client or facility…" />
          <Select value={filters.client || ''} onChange={(e) => setFilter('client', e.target.value)} options={data ? data.clients : []} placeholder="All clients" aria-label="Client" />
          {data && <Select value={filters.status || ''} onChange={(e) => setFilter('status', e.target.value)} options={data.statuses} placeholder="Any status" aria-label="Status" />}
          {Object.values(filters).some(Boolean) && <Button variant="ghost" size="sm" onClick={clearFilters}>Clear</Button>}
          <div className="right">{user.can_edit && <Button variant="primary" icon="plus" onClick={() => setDialog({ type: 'add' })}>Add candidate offer</Button>}</div>
        </div>
        <DataTable columns={columns} paged={paged} rowKey={(r) => r.onboard_id} noun="candidate offers" onRowClick={(row) => setDialog({ type: 'view', row })} />
      </Card>
      {dialog && dialog.type === 'add' && <CandidateForm org={org} onClose={() => setDialog(null)} onSaved={() => { setDialog(null); reload(); }} />}
      {dialog && dialog.type === 'view' && <CandidateDetail candidate={dialog.row} onClose={() => setDialog(null)} onChanged={reload} />}
    </>
  );
}
